import { SUPPORTED_NETWORKS } from "../types/network";
import { Token } from "../store/global/TokenEnum";
import { Chain } from "@rainbow-me/rainbowkit";
import { arbitrum, mainnet, polygon } from "viem/chains";
import { BLOCK_EXPLORER_URL_BY_NETWORK } from "../config/consts";
import { IGlobalStore } from "../store/global/GlobalStore";

export const getChainIdFromName = (name: string): number => {
  const found = SUPPORTED_NETWORKS.find(chain => {
    return chain.name.toLowerCase() === name.toLowerCase();
  });
  if (found) {
    return found.id;
  }

  throw new Error(`Could not find ID for chain name '${name}'`);
};

export const getChainFromName = (name: string): Chain | undefined => {
  return SUPPORTED_NETWORKS.find(chain => chain.name.toLowerCase() === name.toLowerCase());
};
export const getChainFromId = (id: number): Chain | undefined => {
  return SUPPORTED_NETWORKS.find(chain => Number(chain.id) === Number(id));
};

export const getWrappedSymbolForChain = (chain: Chain): Token => {
  if (isEthereumNetworkOrArbitrum(chain)) {
    return Token.WETH;
  } else if (chain.name === polygon.name) {
    return Token.WMATIC;
  }
  throw new Error(`Could not get Wrapped Token match for network: ${chain.name}`);
};

export const isEthereumNetwork = (network: Chain): boolean => {
  return network.id === mainnet.id;
};

// Helps with use cases where Ethereum and Arbitrum share similarities i.e same native token
export const isEthereumNetworkOrArbitrum = (network: Chain): boolean => {
  return network.id === mainnet.id || network.id === arbitrum.id;
};
export const getBlockExplorerForNetwork = (network: Chain): string => {
  const blockExplorer = BLOCK_EXPLORER_URL_BY_NETWORK[network.id];
  if (blockExplorer) {
    return blockExplorer;
  }
  return "";
};

export const isStoredNetworkOutOfSync = (
  storedNetwork: IGlobalStore["network"],
  walletNetworkId: Chain | undefined
) => {
  return storedNetwork.id !== walletNetworkId?.id;
};
